import React, { Component } from 'react';
import loginCheck from '../login/LoginCheck';
import ReactTable from 'react-table';
import FoldableTableHOC from 'react-table/lib/hoc/foldableTable';
import 'react-table/react-table.css';
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Tooltip,
} from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import StatusFilter from './headerFilter/StatusFilter';
import SponsorFilter from './headerFilter/SponsorFilter';
import AckFilter from './headerFilter/AckFilter';
import DateFilter from './headerFilter/DateFilter';

import SubComponent from './table-subcomponent/SubComponent';

import { toast } from 'react-toastify';

import {
  FaSearch,
  FaMoneyCheckAlt,
} from 'react-icons/fa';

//Axios
import 'bootstrap//dist/css/bootstrap.css';

import {
    IoIosCheckmark,
  IoMdCreate,
  IoMdClose,
} from 'react-icons/io';
import { MdTransform } from 'react-icons/md';
// Modal
import IntimationModalCancel from './IntimationModalCancel';
import ConfirmModal from './ConfirmModal';
import IntimationModalConfirm from './IntimationModalConfirm';


import {
  showRequestModal,
  hideRequestModal,
  showIntimationRequestModal,
  hideIntimationRequestModal,
} from '../../actions/index';

import { debounce } from '../../utils/debounce';

import './modal.css';

import Link from 'valuelink';
import { Input } from 'valuelink/lib/tags';

import { Row, Col } from 'reactstrap';

import styled from 'styled-components';

import {
  StatusPendingContainer,
  StatusCompleteContainer,
  StatusDangerContainer,
} from '../common/StatusContainer';

import {
  getAllIntimationRequests,
  cancelRequest,
  callUserRequest,
  shiftIntimationToReimbursement,
  requestPayout,
} from '../../services/api/intimation-request';

import NavBar from '../layout/NavBar';
import RequestDetails from './RequestDetails';

import CallingButton from '../offline-consultations/CallingButton';

import ClaimedByFilter from './headerFilter/ClaimedByFilter';

import ChangeProcessingDateModal from './ChangeProcessingDateModal';
import { RegularText } from '../common/Text';
import StyledTappable from '../common/StyledTappable';
import LoadingComponent from '../common/LoadingComponent';
import IntimationPayout from './intimationPayout';

const FoldableTable = FoldableTableHOC(ReactTable);

const PaddedContainer = styled.div`
  padding: 5px;
`;

const OuterComponent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const SearchBox = styled.div`
  border: 1px solid;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  flex-direction: row;
`;

const SerachBoxInput = styled(Input)`
  border: 0;
  flex: 2 0 0;
  margin: 1px;
  &:focus {
    outline: none;
  }
`;

const SearchBoxContent = styled.div`
  display: inline-block;
  flex: 1 0 0;
  margin: 1px;
  text-align: right;
`;

const ProcessingDateComponent = styled(StyledTappable)``;

const ProcessingDate = styled(RegularText)`
  display: flex;
  font-size: 16px;
  color: ${(props) => props.color || '#46471a'};
`;

class IntimationRequest extends Component {
  tableAllColumns = (status) => [
    {
      Header: 'Request Details',
      foldable: true,
      columns: [
        {
          accessor: 'requestId',
          numeric: true,
          disablePadding: true,
          // filterable: false,
          Filter: (props) => (
            <input
              onChange={(event) =>
                debounce(this.setRequestIdFilter(event), 300)
              }
            />
          ),
          Header: 'RID',
          style: { whiteSpace: 'unset' },
          Cell: (row) => {
            const { requestId, appointmentDate } =
              row.original;
            let color = 'primary';
            return (
              <div>
                <Button
                  type="submit"
                  size="sm"
                  color={color}
                  onClick={() => this.showDetails(requestId)}
                >
                  {requestId}
                </Button>
              </div>
            );
          },
        },
        {
          accessor: 'category_name',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'Cat. Name',
          style: { whiteSpace: 'unset' },
          sortable: false,
        },
        {
          accessor: 'procedure_name',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'Proc. Name',
          style: { whiteSpace: 'unset' },
          sortable: false,
          cell: (row) => {
            return row.original.procedure_name;
          },
        },
        {
          accessor: 'status',
          numeric: false,
          disablePadding: false,
          Header: 'Status',
          style: { whiteSpace: 'unset' },
          sortable: false,
          Filter: (props) => (
            <StatusFilter
              onChangeValue={this.changeStatusFilter}
              value={this.state.statusFilter}
              {...props}
            />
          ),
        },
        {
          accessor: 'actions',
          numeric: true,
          filterable: false,
          disablePadding: false,
          Header: 'Actions',
          sortable: false,
          style: { whiteSpace: 'unset' },
          Cell: (row) => {
            return (
              <div>
                {row.original.status == 'request-received' && (
                  <>
                    <IoIosCheckmark
                      className="icon-style"
                      style={{ fontSize: 25 }}
                      id={`confirmButton-${row.original.requestId}`}
                      onClick={() =>
                        this.confirmOpenModal(
                          row.original.requestId,
                          row.original.category_name
                        )
                      }
                    />
                    <Tooltip
                      placement="top"
                      target={`confirmButton-${row.original.requestId}`}
                      trigger="hover"
                      toggle={() => {
                        const { confirmTooltipOpen } = this.state;
                        this.setState({
                          confirmTooltipOpen:
                            row.original.requestId === confirmTooltipOpen
                              ? -1
                              : row.original.requestId,
                        });
                      }}
                      isOpen={
                        this.state.confirmTooltipOpen === row.original.requestId
                      }
                    >
                      Confirm Appointment
                    </Tooltip>
                  </>
                )}
                {row.original.status != 'request-cancelled' &&
                  row.original.status != 'request-confirmed' && (
                    <>
                      {/* Cancel Appointment */}
                      <IoMdClose
                        className="icon-style"
                        id={`cancelButton-${row.original.requestId}`}
                        onClick={() =>
                          this.cancelOpenModal(row.original.requestId)
                        }
                      />
                      <Tooltip
                        placement="top"
                        target={`cancelButton-${row.original.requestId}`}
                        trigger="hover"
                        toggle={() => {
                          const { cancelTooltipOpen } = this.state;
                          this.setState({
                            cancelTooltipOpen:
                              row.original.requestId === cancelTooltipOpen
                                ? -1
                                : row.original.requestId,
                          });
                        }}
                        isOpen={
                          this.state.cancelTooltipOpen ===
                          row.original.requestId
                        }
                      >
                        Cancel Appointment
                      </Tooltip>
                    </>
                )}
                {/*    Shift to reimbursement*/}
                {row.original.status == 'request-received' && (
                  <>
                    <MdTransform
                      className="icon-style"
                      id={`shiftToReimbursementButton-${row.original.requestId}`}
                      onClick={() =>
                        this.toggleShiftToReimbursementModal(
                          row.original.requestId
                        )
                      }
                    />
                    <Tooltip
                      placement="top"
                      target={`shiftToReimbursementButton-${row.original.requestId}`}
                      trigger="hover"
                      toggle={() => {
                        const { shiftToReimbursementOpen } = this.state;
                        this.setState({
                          shiftToReimbursementOpen:
                            row.original.requestId === shiftToReimbursementOpen
                              ? -1
                              : row.original.requestId,
                        });
                      }}
                      isOpen={
                        this.state.shiftToReimbursementOpen ===
                        row.original.requestId
                      }
                    >
                      Shift To Reimbursement
                    </Tooltip>
                  </>
                )}
                {(row.original.status == 'request-processed' && row.original.booking_status != "booking-payout-complete" && !row.original.payout_status && row.original.category_name != "In-clinic Consultations (OPD)" && row.original.category_name != "Lab Tests" && row.original.mode== "cashless") && (
                  <>
                    <FaMoneyCheckAlt
                      className="icon-style"
                      id={`requestPayout-${row.original.requestId}`}
                      onClick={() =>
                        this.togglePayoutRequestModal(
                          row.original.requestId,
                          row.original.payout_status
                        )
                      }
                    />
                    <Tooltip
                      placement="top"
                      target={`requestPayout-${row.original.requestId}`}
                      trigger="hover"
                      toggle={() => {
                        const { requestPayoutOpen } = this.state;
                        this.setState({
                          requestPayoutOpen:
                            row.original.requestId === requestPayoutOpen
                              ? -1
                              : row.original.requestId,
                        });
                      }}
                      isOpen={
                        this.state.requestPayoutOpen ===
                        row.original.requestId
                      }
                    >
                      Raise Payout Request
                    </Tooltip>
                  </>
                )}
              </div>
            );
          },
        },
        {
          accessor: 'mode',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'Mode',
          style: { whiteSpace: 'unset' },
        },
        {
          accessor: 'sponsorName',
          numeric: false,
          disablePadding: false,
          Header: 'Sponsor',
          style: { whiteSpace: 'unset' },
          Filter: ({ filter, onChange }) => (
            <SponsorFilter
              onChangeValue={this.setSponsorFilter}
              value={this.state.sponsorFilter}
            />
          ),
        },
        {
          accessor: 'appointmentDate',
          numeric: false,
          disablePadding: false,
          Header: 'Appt. Date',
          style: { whiteSpace: 'unset' },
          // filterable: false,
          headerStyle: { overflow: 'visible' },
          Filter: (props) => (
            <DateFilter
              label="Appointment"
              value={this.state.appointmentDateFilter}
              {...props}
              onChangeValue={this.changeAppointmentDateFilter}
            />
          ),
          Cell: (row) => {
            return moment(row.original.appointmentDate).format('DD MMM YY');
          },
        },
        {
          accessor: 'appointmentTime',
          numeric: false,
          disablePadding: false,
          Header: 'Appt. Time',
          style: { whiteSpace: 'unset' },
          // filterable: false,
          headerStyle: { overflow: 'visible' },
          Cell: (row) => {
            return moment(row.original.appointmentTime, 'hh:mm').format(
              'hh:mm A'
            );
          },
        },
        {
          accessor: 'requestedOn',
          numeric: false,
          disablePadding: false,
          Header: 'Req. Date',
          style: { whiteSpace: 'unset' },
          // filterable: false,
          headerStyle: { overflow: 'visible' },
          Filter: (props) => (
            <DateFilter
              label="Request"
              value={this.state.requestDateFilter}
              {...props}
              onChangeValue={this.changeRequestDateFilter}
            />
          ),
          Cell: (row) => {
            return moment(row.original.requestedOn).format('DD MMM Y hh:mm A');
          },
        },
        {
          accessor: 'processedOn',
          numeric: false,
          disablePadding: false,
          Header: 'Process. Date',
          style: { whiteSpace: 'unset' },
          // filterable: false,
          headerStyle: { overflow: 'visible' },
          Filter: (props) => (
            <DateFilter
              label="Processing"
              value={this.state.processingDateFilter}
              {...props}
              onChangeValue={this.changeProcessingDateFilter}
            />
          ),
          Cell: (row) => {
            return (
              <ProcessingDateComponent
                onTap={() => this.changeProcessingDate(row.original)}
              >
                {' '}
                {row.original.processingDate
                  ? moment(row.original.processingDate).format('DD MMM h:mm A')
                  : 'Not Processed'}
              </ProcessingDateComponent>
            );
          },
        },
        {
          accessor: 'patient_name',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'Patient',
          style: { whiteSpace: 'unset' },
        },
        {
          accessor: 'userName',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'User',
          style: { whiteSpace: 'unset' },
        },
        {
          accessor: 'relationship',
          numeric: false,
          filterable: false,
          disablePadding: false,
          Header: 'relationship',
          style: { whiteSpace: 'unset' },
        },
        {
          accessor: 'center_address',
          numeric: false,
          disablePadding: false,
          filterable:false,
          Header: 'Center',
          style: { whiteSpace: 'unset' },
        },
        {
          accessor: 'prescription_link',
          numeric: false,
          disablePadding: false,
          filterable:false,
          Header: 'prescription',
          style: { whiteSpace: 'unset' },
          Cell: (row) => {
            return row.original.prescription_link ?(
              <a href={row.original.prescription_link} target='_blank'>OPEN LINK</a>
            ):'N/A'
          },
        },
        {
          accessor: 'claimedUserName',
          numeric: false,
          disablePadding: false,
          Header: 'Claimed By',
          style: { whiteSpace: 'unset' },
          Filter: ({ filter, onChange }) => (
            <ClaimedByFilter
              onChange={onChange}
              value={filter ? filter.value : ''}
            />
          ),
        },
      ],
    },
    {
      Header: 'Inhouse Details',
      foldable: true,
      columns: [
        {
          accessor: 'acknowledgementCall',
          disablePadding: false,
          Header: 'Ack. Call',
          style: { whiteSpace: 'unset' },
          sortable: false,
          show: status !== 'confirmed',
          Cell: (row) => {
            const {
              requestId,
              userPhone,
              acknowledgementCallCount,
              acknowledgementCallDuration,
            } = row.original;
            let status = 'Pending';
            if (
              acknowledgementCallCount &&
              parseInt(acknowledgementCallDuration) !== 0
            ) {
              status = `Yes (${this.secondsToHms(acknowledgementCallDuration)}, ${acknowledgementCallCount})`;
              return (
                <StatusCompleteContainer>
                  {status}
                  {userPhone && (
                    <CallingButton
                      onSubmit={() => this.setAckButtonConfirmModal(requestId)}
                    />
                  )}
                </StatusCompleteContainer>
              );
            } else if (parseInt(acknowledgementCallCount) !== 0) {
              status = `No Answer (${acknowledgementCallCount})`;
              return (
                <StatusPendingContainer>
                  {status}
                  {userPhone && (
                    <CallingButton
                      onSubmit={() => this.setAckButtonConfirmModal(requestId)}
                    />
                  )}
                </StatusPendingContainer>
              );
            }
            return (
              <StatusDangerContainer>
                {status}
                {userPhone && (
                  <CallingButton
                    onSubmit={() => this.setAckButtonConfirmModal(requestId)}
                  />
                )}
              </StatusDangerContainer>
            );
          },
          Filter: (props) => {
            return <AckFilter {...props} onChange={this.changeAckFitler} />;
          },
        },
      ],
    },
    {
      accessor: 'payout_status',
      disablePadding: true,
      filterable: false,
      Header: 'Payout',
      sortable: false,
      style: { whiteSpace: 'unset' },
    },
    {
      accessor: 'payout_payment_status',
      disablePadding: true,
      filterable: false,
      Header: 'Payout Payment',
      sortable: false,
      style: { whiteSpace: 'unset' },
    }
  ];

  constructor(props) {
    super(props);

    this.debounceSearch = debounce((val) => this.fetchTableData(), 300);

    this.state = {
      loading: true,
      tableColumns: this.tableAllColumns(),
      data: [],
      type: null,
      totalHits: 0,
      confirmModalIsOpen: false,
      confirmRequest: false,
      altRequest: false,
      cancelModalIsOpen: false,
      detail: {},
      cancelRequest: false,
      failRequest: false,
      callRequest: false,
      show: false,
      pages: 0,
      search: '',
      pageSize: 10,
      segregation: null,
      statusFilter: null,
      requestDateFilter: {
        startDate: null,
        endDate: null,
      },
      processingDateFilter: {
        startDate: null,
        endDate: null,
      },
      appointmentDateFilter: {
        startDate: null,
        endDate: null,
      },
      claimedByFilter: '',
      sponsorFilter: null,
      modalHeader: '',
      modalBody: '',
      bgColor: '',
      confirmModal: {
        isOpen: false,
        header: '',
        body: '',
        onSubmit: null,
        requestId: null,
        onClose: null,
        buttonLoading: false,
      },
      requestIdFilter: null,
      isPendingCallbackFilter: null,
      tooltipOpen: false,
      openComms: false,
      commsData: false,
      changeProcessingDateModal: {
        isOpen: false,
        requestId: null,
        processingDate: null,
      },
      cancelTooltipOpen: -1,
      shiftReimbursementModalOpen: false,
      shiftToReimbursementReqId: null,
      shiftToReimbursementOpen: -1,
      requestPayoutOpen : -1,
      requestPayoutOpenModalOpen: false,
      requestPayoutOpenReqId: null,
      requestPayoutStatus: null,
    };
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + "h " : "";
    var mDisplay = m > 0 ? m + "min, ": "";
    var sDisplay = s > 0 ? s + " sec": "";
    return hDisplay + mDisplay + sDisplay; 
}

  componentDidMount() {
    const { location } = this.props;
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.get('sourceId')) {
        this.showDetails(searchParams.get('sourceId'));
      }
    }
  }

  changeProcessingDate = (req) => {
    console.log({ req });

    this.setState({
      changeProcessingDateModal: {
        isOpen: true,
        requestId: req.requestId,
        processingDate: req.processingDate,
      },
    });
  };

  closeProcessingDateModal = () => {
    this.setState({
      changeProcessingDateModal: {
        isOpen: false,
        requestId: null,
        processingDate: null,
      },
    });
    this.fetchTableData();
  };

  //confirm modal
  confirmOpenModal = (requestId, type = null) => {
    this.setState({
      confirmModalIsOpen: true,
      requestId: requestId,
      type: type,
    });
  };

  confirmCloseModal = () => {
    this.setState({ confirmModalIsOpen: false });
  };

  filterMethod = (filter, row) => {
    // Pivoted rows won't contain the column.
    //  If that's the case, we set the to true (allowing us to only filter on the current column)
    const rowValue = row[filter.id];
    if (!rowValue) {
      return true;
    }

    const filterValue = filter.value.filterValue || '';
    const filterType = filter.value.filterType;
    switch (filterType) {
      case 'contains':
        return rowValue.indexOf(filterValue) > -1;
      case 'starts-with':
        return rowValue.startsWith(filterValue);
      case 'ends-with':
        return rowValue.endsWith(filterValue);
      case 'matches':
        return rowValue === filterValue;
      case 'greater-than':
        return rowValue > filterValue;
      case 'less-than':
        return rowValue < filterValue;
      default:
        return true;
    }
  };

  submitUserAcknowledgeCall = (requestId) => {
    if (!requestId) {
      return;
    }
    return callUserRequest(requestId, 'userAcknowledge').then(
      this.fetchTableData
    );
  };

  setSponsorFilter = (sponsorId) => {
    this.setState(
      {
        sponsorFilter: sponsorId,
      },
      this.fetchTableData
    );
  };

  submitUserCall = (requestId) => {
    if (!requestId) {
      return;
    }
    return callUserRequest(requestId, 'user').then(this.fetchTableData);
  };

  submitUserReminded = (requestId) => {
    if (!requestId) {
      return;
    }
    return callUserRequest(requestId, 'userReminder').then(this.fetchTableData);
  };

  showDetails = (requestId) => {
    if (!requestId) {
      return;
    }
    this.props.dispatch(showIntimationRequestModal(requestId));
  };

  // Cancel Modal
  cancelOpenModal = (requestId) => {
    this.setState({ cancelModalIsOpen: true, requestId });
  };

  cancelCloseModal = () => {
    this.setState({ cancelModalIsOpen: false });
  };

  submitCancelModal = (remarks) => {
    const { requestId } = this.state;
    if (!requestId || !remarks.length) {
      console.error({ requestId, remarks }, 'No request id present');
      toast.error('Select a reason to continue');
      return;
    }
    return cancelRequest(requestId, remarks)
      .then((response) => {
        // Handle success response
        toast.success('Cancel Request Success');
      })
      .catch((err) => {
        // Error Handle
        toast.error('Cancel Request fail Please try again');
      })
      .finally(() => {
        // Handle Final (mainly for spinners)
      });
  };

  onFetchData = (state, instance) => {
    let orderBy, orderDir;
    if (state.sorted.length > 0) {
      orderBy = state.sorted[0].id;
      orderDir = state.sorted[0].desc ? 'desc' : 'asc';
    } else {
      orderBy = 1;
      orderDir = 'desc';
    }
    console.log(state, 'State on fetch data');
    let claimedByFilter = '';
    state.filtered.forEach((f) => {
      if (f.id === 'claimedUserName') {
        claimedByFilter = f.value;
      }
    });
    this.setState(
      {
        pageSize: state.pageSize,
        page: state.page,
        orderBy,
        orderDir,
        claimedByFilter,
      },
      this.fetchTableData
    );
  };

  fetchTableData = () => {
    this.setState({
      loading: true,
    });
    const params = {
      draw: this.state.pageSize,
      page: this.state.page,
      orderBy: this.state.orderBy,
      orderDir: this.state.orderDir,
      statusFilter: this.state.statusFilter,
      search: this.state.search || null,
      sponsorFilter: this.state.sponsorFilter,
      claimedByFilter: this.state.claimedByFilter,
    };

    if (this.state.segregation !== null) {
      params.segregation = this.state.segregation;
    }

    if (
      this.state.requestDateFilter.startDate &&
      this.state.requestDateFilter.endDate
    ) {
      params.requestDateFilterStartDate = moment(
        this.state.requestDateFilter.startDate
      ).format('YYYY-MM-DD');
      params.requestDateFilterEndDate = moment(
        this.state.requestDateFilter.endDate
      ).format('YYYY-MM-DD');
    }

    if (
      this.state.processingDateFilter.startDate &&
      this.state.processingDateFilter.endDate
    ) {
      params.processingDateFilterStartDate = moment(
        this.state.processingDateFilter.startDate
      ).format('YYYY-MM-DD');
      params.processingDateFilterEndDate = moment(
        this.state.processingDateFilter.endDate
      ).format('YYYY-MM-DD');
    }

    if (
      this.state.appointmentDateFilter.startDate &&
      this.state.appointmentDateFilter.endDate
    ) {
      params.appointmentDateFilterStartDate = moment(
        this.state.appointmentDateFilter.startDate
      ).format('YYYY-MM-DD');
      params.appointmentDateFilterEndDate = moment(
        this.state.appointmentDateFilter.endDate
      ).format('YYYY-MM-DD');
    }

    if (this.state.requestIdFilter) {
      params.requestId = this.state.requestIdFilter;
    }

    if (this.state.ackFilter) {
      params.acknowledgementCallFilter = this.state.ackFilter;
    }

    if (this.state.isPendingCallbackFilter) {
      params.isPendingCallbackFilter = this.state.isPendingCallbackFilter;
    }

    console.log('params', params);
    return getAllIntimationRequests(params)
      .then((responseBody) => {
        this.setState({
          data: responseBody.result,
          loading: false,
          pages: Math.ceil(responseBody.totalHits / this.state.pageSize),
          totalHits: responseBody.totalHits || 0,
        });
      })
      .catch((err) => {
        console.error({ err, params }, 'error========');
      });
  };

  closeDetailModal = () => {
    this.props.dispatch(hideIntimationRequestModal());
  };

  onChangeOnboardingStatusFilter = (value) => {
    this.setState(
      {
        onboardingStatusFilter: value,
      },
      this.fetchTableData
    );
  };

  setRequestIdFilter = (event) => {
    const { value } = event.target;
    this.setState(
      {
        requestIdFilter: value,
      },
      this.fetchTableData
    );
  };

  setAckButtonConfirmModal = (requestId) => {
    this.setState({
      confirmModal: {
        isOpen: true,
        header: 'Call User?',
        body: 'Are you sure you want to call user?',
        requestId,
        onSubmit: this.submitUserAcknowledgeCall,
        onClose: () => {
          this.setState({ confirmModal: { isOpen: false } });
        },
      },
    });
  };

  

  setCallUserButtonConfirmModal = (requestId) => {
    this.setState({
      confirmModal: {
        isOpen: true,
        header: 'Call User?',
        body: 'Are you sure you want to call user?',
        requestId,
        onSubmit: this.submitUserCall,
        onClose: () => {
          this.setState({ confirmModal: { isOpen: false } });
        },
      },
    });
  };

  submitConfirmModalGen = () => {
    const { onSubmit, requestId } = this.state.confirmModal;
    return onSubmit(requestId).then(() => {
      this.setState({ confirmModal: { isOpen: false } });
    });
  };

  onAction = () => {
    this.fetchTableData();
  };

  changeStatusFilter = (value) => {
    this.setState({ statusFilter: value }, this.fetchTableData);
  };

  changeAckFitler = (value) => {
    this.setState({ ackFilter: value }, this.fetchTableData);
  };

  changeRequestDateFilter = (startDate, endDate) => {
    this.setState(
      {
        requestDateFilter: {
          ...this.state.requestDateFilter,
          startDate,
          endDate,
        },
      },
      this.fetchTableData
    );
  };

  changeProcessingDateFilter = (startDate, endDate) => {
    this.setState(
      {
        processingDateFilter: {
          ...this.state.processingDateFilter,
          startDate,
          endDate,
        },
      },
      this.fetchTableData
    );
  };

  changeAppointmentDateFilter = (startDate, endDate) => {
    this.setState(
      {
        appointmentDateFilter: {
          ...this.state.appointmentDateFilter,
          startDate,
          endDate,
        },
      },
      this.fetchTableData
    );
  };

  clearFilters = () => {
    this.setState(
      {
        appointmentDateFilter: {
          startDate: null,
          endDate: null,
        },
        requestDateFilter: {
          startDate: null,
          endDate: null,
        },
        statusFilter: null,
        ackFilter: null,
        inHouseFilter: null,
        sponsorFilter: null,
        requestIdFilter: null,
        isRescheduledFilter: null,
        isReconfirmationRequiredFilter: null,
        isReconfirmationFilter: null,
        isPendingCallbackFilter: null,
      },
      this.fetchTableData
    );
  };

  toggleRequestReconfirmationModal = (requestId) => {
    const { requestReconfirmationModalOpen } = this.state;
    console.log('toggleShiftToPendingModal', requestId);
    this.setState({
      requestReconfirmationModalOpen: !requestReconfirmationModalOpen,
      requestReconfirmationRequestId: requestId,
    });
  };

  toggleShiftToReimbursementModal = (requestId) => {
    const { shiftReimbursementModalOpen } = this.state;
    console.log('Shift to Reimbursement', requestId);
    this.setState({
      shiftReimbursementModalOpen: !shiftReimbursementModalOpen,
      shiftToReimbursementReqId: requestId,
    });
  };

  togglePayoutRequestModal = (requestId, payout_status) => {
    const {  requestPayoutOpenModalOpen } = this.state;
    console.log('payout request', requestId);
    this.setState({
      requestPayoutOpenModalOpen: !requestPayoutOpenModalOpen,
      requestPayoutOpenReqId: requestId,
      requestPayoutStatus: payout_status,
    });
  };

  shiftAppointmentToReimbursement = (requestId) => {
    this.setState({
      loading: true,
    });
    console.log(`Shifting to reimbursement ${requestId}`);
    shiftIntimationToReimbursement(requestId)
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          this.fetchTableData();
        } else {
          toast.error(res.errorMessage || 'Failed to Shift to reimbursement');
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.errorMessage || 'Failed to Shift to reimbursement');
      })
      .finally(() => {
        this.toggleShiftToReimbursementModal(
          this.state.shiftToReimbursementReqId
        );
        this.setState({
          loading: false,
        });
      });
  };

  requestPayout = () => {
    this.setState({
      loading: true,
    });
    console.log(`Requesting payout ${this.state.requestPayoutOpenReqId}`);
    requestPayout(this.state.requestPayoutOpenReqId)
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          this.fetchTableData();
        } else {
          toast.error(res.errorMessage || 'Failed to request payout');
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.errorMessage || 'Failed to request payout');
      })
      .finally(() => {
        this.togglePayoutRequestModal(this.state.requestPayoutOpenReqId);
        this.setState({
          loading: false,
        });
      });
  };

  onSearchClick = () => {
    const { search, loading } = this.state;
    if (loading) {
      return;
    }
    this.debounceSearch(search);
  };

  render() {
    const {
      loading,
      data,
      pages,
      confirmModal,
      totalHits,
      tableColumns,
      segregation,
    } = this.state;

    const { showRequestDetails, requestId } = this.props.intimation;

    const searchLink = Link.state(this, 'search');

    return (
      <OuterComponent>
        <NavBar />
        <PaddedContainer className="pt-4 mt-5">
          <Row>
            <div className="col">
              <div className="row">
                <div className="col-8">
                  <SearchBox>
                    <SerachBoxInput
                      valueLink={searchLink}
                      type="text"
                      placeholder="Search..."
                      onKeyDown={(e) =>
                        e.key === 'Enter' ? this.onSearchClick() : null
                      }
                    />
                    <SearchBoxContent>{totalHits} records</SearchBoxContent>
                  </SearchBox>
                </div>
                <div className="col-1">
                  {this.state.loading ? (
                    <LoadingComponent />
                  ) : (
                    <button
                      onClick={this.onSearchClick}
                      className="btn btn-primary"
                    >
                      <FaSearch />
                    </button>
                  )}
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </Row>
        </PaddedContainer>

        <FoldableTable
          filterable
          data={data}
          columns={tableColumns}
          loading={loading}
          pages={pages}
          manual
          onFetchData={this.onFetchData}
          showPaginationTop={true}
          className="-striped -highlight"
          SubComponent={(row) => (
            <SubComponent
              requestId={row.original.requestId}
              userId={row.original.userId}
            />
          )}
          pageSizeOptions={[5, 10, 20, 25, 50, 100, 1000, 10000, 100000]}
          defaultSorted={[
            {
              id: 'requestedOn',
              desc: true,
            },
          ]}
        />

        <Modal
          isOpen={showRequestDetails}
          toggle={this.closeDetailModal}
          size="lg"
          className="rtsp-modal-big"
        >
          <ModalHeader
            className="bg-primary"
            toggle={this.closeDetailModal}
          >{`Request Details (${requestId})`}</ModalHeader>
          <ModalBody>
            <RequestDetails />
          </ModalBody>
        </Modal>
        {this.state.confirmModalIsOpen && (
          <IntimationModalConfirm
            modalIsOpen={this.state.confirmModalIsOpen}
            openModal={this.confirmOpenModal}
            closeModal={this.confirmCloseModal}
            onComplete={this.onAction}
            type={this.state.type}
            requestId={this.state.requestId}
          />
        )}
        <IntimationModalCancel
          modalIsOpen={this.state.cancelModalIsOpen}
          openModal={this.cancelOpenModal}
          closeModal={this.cancelCloseModal}
          submitModal={this.submitCancelModal}
          onComplete={this.onAction}
          requestId={this.state.requestId}
        />

        {/*  Shift To Reimbursement Modal*/}
        <Modal
          isOpen={this.state.shiftReimbursementModalOpen}
          toggle={this.toggleShiftToReimbursementModal}
        >
          <ModalHeader
            className="bg-primary"
            toggle={this.toggleShiftToReimbursementModal}
          >
            {`Shift to Reimbursement (Request Id: ${this.state.shiftToReimbursementReqId})`}
          </ModalHeader>
          <ModalBody>
            {this.state.loading ? (
              <LoadingComponent />
            ) : (
              <Button
                type="submit"
                size="sm"
                onClick={() =>
                  this.shiftAppointmentToReimbursement(
                    this.state.shiftToReimbursementReqId
                  )
                }
              >
                Confirm
              </Button>
            )}
          </ModalBody>
        </Modal>

        {/*  Request Payout Modal*/}
        <Modal
          isOpen={this.state.requestPayoutOpenModalOpen}
          toggle={this.togglePayoutRequestModal}
          style= {{ maxWidth : '1000px', width: '100%', zIndex: 10}}
        >
          <ModalHeader
            className="bg-primary"
            toggle={this.togglePayoutRequestModal}
          >
            {`Request Payout (Request Id: ${this.state.requestPayoutOpenReqId})`}
          </ModalHeader>
          <ModalBody>
            {/* {this.state.loading ? (
              <LoadingComponent />
            ) : (
              <Button
                type="submit"
                size="sm"
                onClick={() =>
                  this.requestPayout(
                    this.state.requestPayoutOpenReqId
                  )
                }
              >
                Confirm
              </Button>
            )} */}
            <IntimationPayout
            onRequestPayout= {this.requestPayout}
            requestId={this.state.requestPayoutOpenReqId}
            payout_status={this.state.requestPayoutStatus}
            />
          </ModalBody>
        </Modal>
        <ConfirmModal
          modalHeader={confirmModal.header}
          onClose={confirmModal.onClose}
          isOpen={confirmModal.isOpen}
          onSubmit={this.submitConfirmModalGen}
          loading={confirmModal.buttonLoading}
        >
          {confirmModal.body}
        </ConfirmModal>

        <ChangeProcessingDateModal
          requestId={this.state.changeProcessingDateModal.requestId}
          processingDate={this.state.changeProcessingDateModal.processingDate}
          isOpen={this.state.changeProcessingDateModal.isOpen}
          closeProcessingDateModal={this.closeProcessingDateModal}
        />
      </OuterComponent>
    );
  }
}

const mapStateToProps = (state) => ({
  intimation: state.intimation,
});

export default connect(mapStateToProps)(loginCheck(IntimationRequest));
